module.exports = __webpack_public_path__ + "media/images/badgeIcon-b58cdb77.svg";